<template>
  <section>
    <div class="form-header">
      <h1>Unlock your Account</h1>
      <h3>Step 2: Select a verification device</h3>
    </div>
    <hr>
    <div>
      <br>
      <b-form @submit="onSubmit" v-if="show" autocomplete="off">
        <!-- Vertical radio list for contact methods -->
        <b-form-group class="radios">
          <div
            v-for="(option, idx) in options"
            :key="option.text"
            class="form-check"
          >
            <input
              class="form-check-input"
              type="radio"
              :id="`contact-${idx}`"
              name="contactMethod"
              :value="option.value"
              v-model="selected"
            >
            <label class="form-check-label" :for="`contact-${idx}`">{{ option.text }}</label>
          </div>
        </b-form-group>
        <b-form-group id="methodValueLabel">
          <b-form-input id="methodValue"
                        type="text"
                        v-model="methodValue"
                        required
                        placeholder="value">
          </b-form-input>
          <small class="form-text text-muted" id="methodHelp">Please enter the full email or phone number selected</small>
        </b-form-group>
        <div id="form-info">
          <p>A security code will be sent to the sms or email that you provided for password resets.</p>
        </div>
        <div><b-button type="submit" variant="primary">Next</b-button>
          <app-spinner v-if="spinner"/></div>
      </b-form>
      <div v-else>
        <div id="no-valid">
          <p>There are no valid contact methods associated with this Account.</p>
          <!--p>Please complete the Account Claim process to update your Contact Methods</p-->
        </div>
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal ref="alertModal" :title=alertHeader :ok-only="true">
      <p class="my-4">{{alertText}}</p>
      <template #footer>
        <div class="w-100">
          <b-button v-if="alertNav==='home'" size="sm" class="float-end" variant="primary" @click="navigateHome()">
            Okay
          </b-button>
          <b-button v-if="alertNav==='here'" size="sm" class="float-end" variant="primary" @click="navigateHere()">
            Okay
          </b-button>
        </div>
      </template>
    </b-modal>
  </section>
</template>

<script>
/***************************************************
 * The FormULA2 component
 *
 * Page 2 of the Unlock Account Orchestration
 *
 * Allows Choice of contact method
 * Calls sendOTPCode api
 *
 ***************************************************/

import { useFormDataStore } from '../../stores/formData'
import { useLocalApiStore } from '../../stores/localApi'
import { useFormOrchestrationStore } from '../../stores/formOrchestration'
import Spinner from '../Spinner.vue'

export default {
  name: 'FormULA2',
  components: {
    'app-spinner': Spinner
  },
  data () {
    return {
      alertHeader: '',
      alertText: '',
      alertNav: 'here',
      show: true,
      contactType: '',
      contactValue: '',
      contactData: '',
      spinner: false,
      options:[]
    }
  },
  computed: {
    getValidationDevices () {
      const fd = useFormDataStore()
      return fd.getValidationDevices
    },
    getSessionKey () {
      const fd = useFormDataStore()
      return fd.getSessionKey
    },
    methodValue: {
      get () { const fd = useFormDataStore(); return fd.formData.methodValue },
      set (value) { const fd = useFormDataStore(); fd.updateMethodValue(value) }
    },
    selected: {
      get () { const fd = useFormDataStore(); return fd.formData.selected },
      set (value) { const fd = useFormDataStore(); fd.updateSelected(value) }
    },
  },
  methods: {
    updateCurrentForm (formName) { const fo = useFormOrchestrationStore(); return fo.updateCurrentForm(formName) },
    clearData () { const fd = useFormDataStore(); return fd.clearData() },
    setSessionKey (k) { const fd = useFormDataStore(); return fd.setSessionKey(k) },
    sendOtpCode (p) { const api = useLocalApiStore(); return api.sendOtpCode(p) },
    async onSubmit (evt) {
      evt.preventDefault();
      this.spinner = true;

      let i;
      let selectedOption = {};
      for (i = 0; i < this.options.length; i++) {
        if (this.options[i].value === this.selected) {
          selectedOption = this.options[i]
        }
      }
      const fd = useFormDataStore(); fd.updateSelected(selectedOption.value)

      //send otp
      let address = ''
      if (selectedOption.value === 'email'){
        address = this.methodValue;
      } else if (selectedOption.value === 'sms') {
        address = this.methodValue.replace(/\(|\)|-/g, '');
      }

      let params = {
        sessionKey: this.getSessionKey,
        address,
        otpType: selectedOption.value
      };
      let results = await this.sendOtpCode(params);
      if (results.result.toUpperCase() === 'FAILURE') {
        // If session is invalid on step 2, refresh session and send user back to step 1
        if (results.resultMessage === 'Invalid Session Encountered') {
          const api = useLocalApiStore();
          this.setSessionKey(await api.newSessionKey());
          this.spinner = false;
          this.updateCurrentForm('FormULA1');
          return;
        }
        let failMessage;
        if (results.resultMessage) {
          failMessage = results.resultMessage + '\n\n If you feel you reached this message in error, please contact support@campingworld.com for assistance.'
        } else {
          failMessage = 'General Failure: Please contact support@campingworld.com for assistance.'
        }
        this.spinner = false;
        this.showAlertModal('Request Failure', failMessage, 'here')
      } else {
        const fd2 = useFormDataStore(); fd2.updateSelected(selectedOption.value)

        // Handle Navigation
        this.spinner = false;
        this.updateCurrentForm('FormULA3')
      }

    },
    setSelectedOptionData () {
      let i = 0;
      while (i < this.options.length) {
        if (this.options[i].type === this.selected) {
          this.contactValue = this.options[i].value;
          this.contactData = this.options[i].data
        }
        i++
      }
    },
    showAlertModal (header, text, nav) {
      this.alertNav = nav;
      this.alertHeader = header;
      this.alertText = text;
      this.$refs.alertModal.show()
    },
    hideAlertModal () {
      this.$refs.alertModal.hide()
    },
    navigateHome () {
      this.hideAlertModal();
      this.clearData();
      this.$router.push('/')
    },
    navigateHere () {
      this.hideAlertModal()
    }
  },
  watch: {
    form: function () {
      this.setSelectedOptionData()
    }
  },
  mounted () {
    if (this.getValidationDevices && this.getValidationDevices.length > 0) {
      this.options = this.getValidationDevices;
      this.setSelectedOptionData();
      // Set Show to true if there are validation devices, and false, if there are none
      this.show = true;
    } else {
      this.show = false;
      this.showAlertModal('Warning', 'There are no valid contact methods associated with this Account. Please contact support@campingworld.com for assistance.', 'home')
    }
  }
}
</script>

<style scoped>
  form-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 25px 0;
  }

  h1 {
    font-weight: bold;
    color: #000;
  }

  h3 {
    color: #4A4A4A;
  }

  form {
    display: flex;
    flex-direction: column;
  }
  /* Ensure the radios stack vertically with clean spacing */
  .radios {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .form-check-label { font-weight: 600; margin-left: 0.35rem; }
  #methodValue {
    width: 320px;
  }
  /* Ensure helper text appears below the input for this group */
  #methodValueLabel.b-form-group { display: block; }
  #methodValueLabel .form-text { display: block; }

  .b-form-group {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
/*    width: 550px; */
    color: #000;
    font-weight: normal;
  }
  /* Override flex layout inside our radios group so items don't spread horizontally */
  .radios.b-form-group { justify-content: flex-start; align-items: flex-start; }

  button {
    margin: 15px 0px;
    background-color: #5487BA;
    width: 100px;
    font-weight: bold;
  }

  button:hover {
    background-color: #123A5D;
  }

  /*.form-control {
    width: 650px;
  }*/

  #form-info {
    background-color: #f5f5f5;
    width: 100%;
    font-size: 1rem;
    padding: 10px;
    text-align: left;
  }
  #no-valid {
    background-color: #f5f5f5;
    width: 100%;
    font-size: 1rem;
    padding: 10px;
    text-align: left;
  }
</style>
